<div class="row text-center" *ngIf="month_display">
  <div class="col-md-12 col-sm-12">
    <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'es' | titlecase }}</h3>
  </div>
  <div class="col-md-12 col-sm-12" *ngIf="events.length">
    <ng-template #customCellTemplate let-day="day" let-locale="locale">
      <div class="cal-cell-top">
        <div class="date-container">
          <span class="cal-day-badge" *ngIf="day.badgeTotal"> Ciclo {{ day.badgeTotal }}</span>
          <span class="cal-day-badge" *ngIf="(day.date | date:'shortDate')===(daydisplay | date:'shortDate')">{{cycledate}}</span>
          <span class="cal-day-number" month="">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
        </div>
        <small>
          <div *ngFor="let event of day.events">
            <div class="container holiday" *ngIf="event.type=='holiday' && day.inMonth">
              <div class="row">
                <div class="col-md-12 holidayevent">
                  <span mwlCalendarTooltip={{event.fullname}} [tooltipEvent]="dayEvent"
                    [tooltipTemplate]="cellTooltipTemplate"
                    [tooltipPlacement]="'top'">{{ event.title | titlecase }}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let event of day.events;let i=index">
            <div class="container legends" *ngIf="event.title !== '' && event.type === 'legends' && day.inMonth">
              <div class="row ">
                <div class="col-md-12   eventwrapper">
                  <div class="eventbullets">
                    <div (click)="editevent(event)" mwlDraggable [class.cal-draggable]="event.draggable"
                      dragActiveClass="cal-drag-active" [dropData]="{event: event, draggedFrom: day}"
                      [dragAxis]="{x: event.draggable, y: event.draggable}">
                      <i class="fas fa-circle-css eventday circle-icon"
                        [ngStyle]="{'background-color': event.color}"></i>
                      <span>{{ event.title | titlecase }}</span>
                    </div>
                    <!-- <span 
                  class="eventday"
                  mwlDraggable
                  [class.cal-draggable]="event.draggable"
                  dragActiveClass="cal-drag-active"
                  [dropData]="{event: event, draggedFrom: day}"
                  [dragAxis]="{x: event.draggable, y: event.draggable}">
                  <i class="fas fa-circle-css eventday circle-icon" [ngStyle]="{'background-color': event.color}"></i>
                    
                </span>
                <span (click)="editevent(event)">
                  {{ event.title | titlecase }}
                </span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </small>
      </div>
    </ng-template>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [locale]="locale" [refresh]="refresh"
          [weekStartsOn]="weekStartsOn" [weekendDays]="weekendDays" [cellTemplate]="customCellTemplate"
          (beforeViewRender)="beforeMonthViewRender($event)" *ngIf="month_display"
          (eventTimesChanged)="eventTimesChanged($event)"></mwl-calendar-month-view>
      </div>
    </div>
  </div>
</div>
<ng-template #warningContentModal let-modal>
  <div class="modal-body">
    {{warningMessage}}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close('Save click')">Aceptar</button>
  </div>
</ng-template>